import Image from 'next/image';
import type { FC } from 'react';
import React, { useEffect } from 'react';
import { Container } from '@/DesignSystem/Component';
import { FILE_BROWSER_URL } from '@/Module/Core/Constant';
import { getPostListAction } from '@/Module/Post/Store/Action';
import { useAppDispatch } from '@/Module/Store/Hook';
import HomePageBlogHeader from './HomePageBlogHeader';
import HomePageBlogList from './HomePageBlogList';
const HomePageBlog: FC = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getPostListAction());
  }, []);
  return <div data-sentry-component="HomePageBlog" data-sentry-source-file="HomePageBlog.tsx">
      <div className="relative bg-blackTwo  py-8 md:py-20 xl:py-32">
        <Image className="z-0" fill style={{
        objectFit: 'cover',
        objectPosition: 'center'
      }} alt="bg" src={`${FILE_BROWSER_URL}/img/teacher-list-Light.svg`} data-sentry-element="Image" data-sentry-source-file="HomePageBlog.tsx" />
        <Container className="relative z-10" data-sentry-element="Container" data-sentry-source-file="HomePageBlog.tsx">
          <HomePageBlogHeader data-sentry-element="HomePageBlogHeader" data-sentry-source-file="HomePageBlog.tsx" />
          <HomePageBlogList data-sentry-element="HomePageBlogList" data-sentry-source-file="HomePageBlog.tsx" />
        </Container>
      </div>
    </div>;
};
export default HomePageBlog;